import { render, staticRenderFns } from "./CourseStudentsSlidebar.vue?vue&type=template&id=4567da33"
import script from "./CourseStudentsSlidebar.vue?vue&type=script&lang=js"
export * from "./CourseStudentsSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports